import { List } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { TopBar } from "../../components/baseComponents";
import ListView from "../../components/baseComponents/ListView/ListView";
import Search from "../../components/baseComponents/SearchComponent/Search";
import { EazyLoader } from "../../components/EazyLoader";
import { ProjectBasicInfo } from "../../store/projectStore";
import { useMst } from "../../store/root";
import { dateFormatter, sortByDate } from "../../store/utils/utilMethods";
import styles from "./HomePage.module.scss";
import InformationCard from "./InformationCard";
const INFO_LINK =
  "https://blings.s3.eu-west-1.amazonaws.com/extension-remote-data/data.json";

type Props = {
  environment: string;
};
const HomePage = observer(({ environment }: Props) => {
  const {
    projectStore: { allProjects, setSelectedProject, isLoading },
    uiStore: { setCreateProjectModalVisible },
    authStore: { userEmail, newSession },
  } = useMst();
  const [searchInput, setSearchInput] = React.useState("");

  // If is internal user, add account name next to each project
  const [isInternalUser, setIsInternalUser] = React.useState(false);

  useEffect(() => {
    if (userEmail) {
      const domain = userEmail.substring(userEmail.indexOf("@") + 1);
      domain === "blings.io" && setIsInternalUser(true);
    }
  }, [userEmail]);

  const renderItemInList = (item: any) => {
    return (
      <List.Item
        className={styles.ListItem}
        onClick={() => setSelectedProject(item.id)}
      >
        <p className={styles.Item}>
          {item.title}
          <span style={{ color: "#5F676B" }}>
            {isInternalUser ? ` | ${item.projectAccountId as string}` : ""}
          </span>
        </p>
        <p className={styles.Date}>
          {dateFormatter(new Date(item?.draftUpdatedAt || item?.updatedAt))}
        </p>
      </List.Item>
    );
  };

  const sortProjects = (
    a: ProjectBasicInfo,
    b: ProjectBasicInfo //Sort by latest edit in draft
  ) =>
    sortByDate(
      a?.draftUpdatedAt || a.updatedAt,
      b?.draftUpdatedAt || b.updatedAt
    );

  return (
    <div className={[styles.HomePage, "HomePage"].join(" ")}>
      <TopBar
        setSelectedProjectId={setSelectedProject}
        environment={environment}
        email={userEmail || ""}
        setCreateProjectModalVisible={setCreateProjectModalVisible}
      />
      {newSession ? (
        <InformationCard
          header={"Blings Knowledge Base"}
          body={"View the latest updates and news from Blings"}
          link1={"https://blings.gitbook.io/blings-knowledge-base"}
          link2={"https://blings.gitbook.io/blings-knowledge-base"}
        />
      ) : (
        ""
      )}
      {!isLoading && allProjects.length ? (
        <>
          <div className={styles.ProjectList}>
            <Search
              value={searchInput}
              onChange={setSearchInput}
              placeholder="Select Project"
            />
            <ListView
              dataSource={[...allProjects]}
              searchInput={searchInput}
              renderItem={renderItemInList}
              sortFunc={sortProjects}
              style={{
                height: newSession
                  ? "calc(100vh - 20rem)"
                  : "calc(100vh - 14rem)",
              }}
            />
          </div>
        </>
      ) : (
        <>
          <p id={styles.CreateNewProject}>
            {!isLoading ? "Create a new project by clicking the plus icon" : ""}
          </p>
          <div className={styles.EazyAnimation}>
            <EazyLoader size={600} isLoop={false} />
          </div>
          <p id={styles.NoProjects}>
            {!isLoading ? "You do not have any projects yet" : ""}
          </p>
        </>
      )}
    </div>
  );
});

export default HomePage;
